import Button from '@mui/material/Button'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { OrderProduct } from '../../entities/order-product/OrderProduct'
import ProductDeclineModal from '../product-decline-modal/ProductDeclineModal'
import Tooltip from '@mui/material/Tooltip'
import messages from './ProductDeclineButton.messages'

interface IOwnProps {
  product: OrderProduct
  onModalClose?: () => void
}

export type IProps = IOwnProps

interface ITooltipContainer {
  product: OrderProduct
}

const TooltipContainer: React.FC<ITooltipContainer> = (props) => {
  const { children, product } = props

  const intl = useIntl()

  if (product.isLabeled) {
    return (
      <Tooltip
        title={intl.formatMessage({ ...messages.tooltip })}
        arrow
      >
        <span>
          {children}
        </span>
      </Tooltip>
    )
  }

  return <>{children}</>
}

const ProductDeclineButton: React.FC<IProps> = (props) => {
  const { product, onModalClose } = props

  const intl = useIntl()

  const [isDeclineModalOpen, setIsDeclineModalOpen] = React.useState(false)

  const handleDeclineClick = () => {
    setIsDeclineModalOpen(true)
  }

  const handleDeclineModalClose = () => {
    setIsDeclineModalOpen(false)
    if (onModalClose) {
      onModalClose()
    }
  }

  return (
    <>
      <TooltipContainer product={product}>
        <Button
          disabled={product.isLabeled}
          onClick={handleDeclineClick}
          variant='contained'
          color='secondary'
          fullWidth={true}
          aria-label={intl.formatMessage({ ...messages.decline })}
        >
          <FormattedMessage {...messages.decline} />
        </Button>
      </TooltipContainer>

      <ProductDeclineModal
        onClose={handleDeclineModalClose}
        product={product}
        open={isDeclineModalOpen}
      />
    </>
  )
}

export default ProductDeclineButton
